import { useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { baseurl } from "../Component/BaseUrl/Baseurl";

function LogoutComponent({ tokenExpirationMsg }) {
  const userData = useSelector((state) => state.userDetails);
  useEffect(() => {
    if (
      tokenExpirationMsg === "Token Blacklisted..." ||
      tokenExpirationMsg === "Session Expired..."
    ) {
      axios({
        method: "PUT",
        url: baseurl + "/api/logout?userId=" + userData.userId,

        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + userData.tokenid,
        },
      })
        .then((response) => {})
        .catch((error) => {
          console.error(error);
        });
      localStorage.clear();
      sessionStorage.clear();

      window.location.href = "/";
    }
  }, [tokenExpirationMsg, userData]);

  return null;
}

export default LogoutComponent;
